export * from '@alloc/types';
//# sourceMappingURL=types.util.js.map